<!-- 离心机筛选 -->
<template>
<div>
    <!-- 顶部搜索组件 -->
    <roof-search v-model="showTypeFilter" v-if="showNav" @searchInputChange="searchInputChange" :showNewIcon="2"></roof-search>
    <div class="centrifuge-product-content footer" ref="activity_scroll" @scroll="activityScroll">
    <div class="product-content-container">
      <div class="item">
        <div class="item-bottom">
          <div class="option" @click="goDetails(item)" v-for="item in productList" :key="item.id">
            <div class="img-cover">
              <!--              <img :src="cdnUrl+item.cover_img" alt="" class="img">-->
              <van-image :src="cdnUrl+item.product_img" fit="cover" alt="" class="img"/>
              <span>12 x1.5/2.0 mL 离心管</span>
              <!-- <span>{{ item.desc }}</span> -->
            </div>
            <div class="product-title">{{item.product_title}}</div>
          </div>
        </div>
        <div class="no-data" v-show="noProduct">
          <img src="@/assets/img/no-data.png" alt="" class="no-data-img" width="100%">
          <p class="hint-text">暂无产品</p>
        </div>
      </div>
    </div>
  </div>
   <!-- 应用筛选组件 -->
    <!-- <apply-filter v-if="isTypeFilter" v-show="showTypeFilter" v-model="showTypeFilter" @typeIdChange="typeIdChange"></apply-filter> -->
    <!-- 新版筛选 -->
    <!-- <new-apply-filter v-if="isTypeFilter" v-show="showTypeFilter" v-model="showTypeFilter" @typeIdChange="typeIdChange"></new-apply-filter> -->
</div>

</template>

<script>
import cdnUrl from '@/config/index'
import roofSearch from './components/roof-search'
import applyFilter from './components/applyFilter'
import newApplyFilter from './components/newApplyFilter'
import { getNewProductList } from '@/api/centrifuge'
import { wxShare } from '@/libs/wxjssdk'
import { getProductList } from '@/api/product'
export default {
    data () {
        return {
            cdnUrl: cdnUrl.baseUrl.cdnUrl,
            productList: [],
            showMoreBtn: '更多',
            showFiltrate: true,
            conditionList: [], // 筛选条件列表
            noProduct: false,
            showNav: true,
            showTypeFilter: false,
            last_page: 1,
            requestParams: {
                type_id: '',
                search: '',
                page: 1
            },
            isTypeFilter: true,
            createdState: false, // 是不是第一次进来的
            currentFilter: false // 当前是不是在筛选产品
        }
    },
    components: {
        roofSearch, applyFilter, newApplyFilter
    },
    created () {
        console.log('created...')
        this.createdState = true
        this.productList = []
        this.isTypeFilter = true
        this.getProductListPort()
        this.sharePage()
    },
    computed: {
        whetherSignature () {
            return this.$store.state.user.whetherSignature
        }
    },
    watch: {
        whetherSignature (newVAl) {
            if (newVAl === true) {
                this.sharePage()
            }
        }
    },
    activated () {
        if (this.createdState) {
            return false
        }
        const refresh = this.$store.state.centrifugeRefresh
        console.log('activated...', refresh)
        this.showNav = true
        this.isTypeFilter = true
        this.sharePage()
        if (refresh) {
            this.requestParams = {
                type_id: '',
                search: '',
                page: 1
            }
            this.productList = []
            this.currentFilter = false
            this.getProductListPort()
        }
    },
    deactivated () {
        this.showNav = false
        this.isTypeFilter = false
        this.showTypeFilter = false
        this.createdState = false
    },
    methods: {
        sharePage () {
            const params = {
                title: 'Eppendorf 离心机筛选', // 分享标题
                desc: 'Eppendorf 离心机筛选', // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            wxShare(params)
        },
        // 上拉触底
        activityScroll () {
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 5 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.requestParams.page < this.last_page) {
                    this.requestParams.page++
                    if (this.currentFilter) {
                        this.getNewProductListPort()
                    } else {
                        this.getProductListPort()
                    }
                }
            }
        },
        // 搜索框发生变化
        searchInputChange (val) {
            this.requestParams.page = 1
            this.requestParams.type_id = ''
            this.requestParams.search = val
            this.productList = []
            this.getNewProductListPort()
        },
        // 选中了类别id之后
        typeIdChange (typeId) {
            this.requestParams.page = 1
            this.requestParams.type_id = typeId
            // this.requestParams.type_parent_id = typeId
            this.productList = []
            this.currentFilter = true
            this.getNewProductListPort()
            this.$store.commit('setCentrifugeRefresh', false)
        },
        goDetails (item) {
            // console.log('item', item)
            if (item.default) {
                this.$router.push({
                    name: 'productDetails',
                    query: {
                        id: item.id
                    }
                })
            } else {
                this.$router.push({
                    name: 'centrifugeDetails',
                    query: {
                        id: item.id
                    }
                })
            }
        },
        // 处理离心机默认的数据
        disposeDefaultData (dataList) {
            if (dataList.length) {
                return dataList.map((val) => {
                    val.default = 1
                    val.product_img = val.cover_img
                    val.product_title = val.title
                    return val
                })
            } else {
                return []
            }
        },
        // 处理筛选得数据
        disposeData (dataList) {
            if (dataList.length) {
                return dataList.map((val) => {
                    val.product_img = JSON.parse(val.product_img)[0] || ''
                    return val
                })
            } else {
                return []
            }
        },
        /** 网络请求 **/
        // 获取离心机的产品（默认数据）
        getProductListPort () {
            this.$toast.loading({
                message: '数据加载中...',
                forbidClick: true,
                duration: 0
            })
            var paramsData = {
                parent_category_id: 106, // 默认为离心机的id
                page: this.requestParams.page,
                size: 10
            }
            getProductList(paramsData).then((res) => {
                if (res.errCode === 0) {
                    this.$toast.clear()
                    var data = res.data
                    const { last_page: lastPage, data: dataList } = data
                    this.last_page = lastPage
                    const productList = this.disposeDefaultData(dataList)
                    this.productList.push(...productList)
                    this.productList.length ? this.noProduct = false : this.noProduct = true
                    // console.log('data', dataList)
                } else {
                    this.$toast(res.errMsg)
                }
            })
        },
        // 通过筛选条件筛选的数据
        getNewProductListPort () {
            this.$toast.loading({
                message: '数据加载中...',
                forbidClick: true,
                duration: 0
            })
            const params = { ...this.requestParams }
            getNewProductList(params).then(res => {
              console.log('产品数据', res);
              // res.data.data[0].desc = '描述信息'
                if (res.errCode === 0) {
                    this.$toast.clear()
                    var data = res.data
                    const { last_page: lastPage, data: dataList } = data
                    this.last_page = lastPage
                    const productList = this.disposeData(dataList)
                    this.productList.push(...productList)
                    this.productList.length ? this.noProduct = false : this.noProduct = true
                    // console.log('data', dataList)
                } else {
                    this.$toast(res.errMsg)
                }
            }).catch(err => {
                console.log(err)
                this.$toast.clear()
                this.$toast('数据加载失败')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
  .centrifuge-product-content {
    width: 100%;
    height: 100vh;
    background: #F4F4F4;
    padding-top: rem(121);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    &:after{
        content: '';
        background: #F4F4F4;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        z-index: -1;
    }
  }
  .transform-up {
    transform: rotate(-180deg);
  }
.product-content-container{
  border-radius: 4px;
  width: 90%;
  margin: 0 auto;
  .item{
    &:last-child{
      margin-bottom: rem(20);
    }
    .item-middle{
      .filtrate-container{
        //.filter-btn{
        //  border-radius: 4px;
        //  height: rem(30);
        //  line-height: rem(30);
        //  margin-bottom: rem(8);
        //  &:not(:last-child){
        //    margin-right: rem(6);
        //  }
        //}
        //.van-button--normal{
        //  padding: 0 10px;
        //}
        .item{
          &:after{
            content: '';
            display: block;
            clear: both;
          }
          .left-btn {
            height: rem(40);
            float: left;
            display: flex;
            align-items: center;
            margin-right: rem(10);
            .filter-btn{
              border-radius: 4px;
              height: rem(30);
              line-height: rem(30);
              &:not(:last-child){
                margin-right: rem(6);
              }
            }
            .van-button--normal{
              padding: 0 10px;
            }
          }
          .right-label{
            height: rem(40);
            float: left;
            display: flex;
            align-items: center;
            .label-item{
              color: #9d9d9d;
              font-size: 12px;
              display: inline-block;
              height: rem(20);
              line-height: rem(20);
              text-align: center;
              border: 1px solid #9d9d9d;
              border-radius: rem(50);
              padding: 0 rem(12);
              position: relative;
              span{
                display: inline-block;
                width: 100%;
                height: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
              }
              .close-icon{
                width: rem(14);
                height: rem(14);
                position: absolute;
                top: rem(-5);
                right: rem(-5);
                z-index: 99;
                .close-img{
                  width: 100%;
                }
              }
            }
          }

        }

      }
      //.label-container{
      //  margin: rem(15) 0 rem(10);
      //  .label-item{
      //    color: #9d9d9d;
      //    font-size: 12px;
      //    display: inline-block;
      //    height: rem(20);
      //    line-height: rem(20);
      //    text-align: center;
      //    margin-bottom: rem(8);
      //    border: 1px solid #9d9d9d;
      //    border-radius: rem(50);
      //    padding: 0 rem(12);
      //    margin-right: rem(10);
      //    position: relative;
      //    .close-icon{
      //      width: rem(14);
      //      height: rem(14);
      //      position: absolute;
      //      top: rem(-5);
      //      right: rem(-5);
      //      z-index: 999;
      //      .close-img{
      //        width: 100%;
      //      }
      //    }
      //  }
      //}
      .screen-result {
        background: #F0F0F0;
        border-radius: 6px;
        padding-bottom: rem(10);
        margin-bottom: rem(20);
        .header-screen{
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: rem(10);
          padding-right: rem(5);
          height: rem(50);
          .left-title{
            color: #4D4D4D;
            font-size: rem(14);
            font-weight: bold;
          }
          .right-more{
            color: #9D9D9D;
            font-size: rem(12);
            display: flex;
            align-items: center;
            justify-content: center;
            .icon{
              width: rem(30);
              height: rem(30);
              transform: rotate(90deg);
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
        .list{
          padding: 0 rem(10);
          .options{
            color: #4D4D4D;
            line-height: 23px;
            font-size: rem(12);
            &:not(:first-child) {
              margin-top: rem(10);
            }
            &:not(:last-child) {
              border-bottom: 1px solid #dfdfdf;
            }
          }
        }
      }
    }
    .item-bottom{
        position: relative;
        z-index: 9;
      &:after{
        content: '';
        display: block;
        clear: both;
      }
      .option{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: rem(158);
        // height: rem(170);
        height: rem(150);
        background: #fff;
        margin-bottom: rem(15);
        // padding: rem(20) rem(20) rem(10);
        border-radius: 5px;
        &:nth-child(odd){
          float: left;
        }
        &:nth-child(even){
          float: right;
        }
        .img-cover{
          display: flex;
          justify-content: space-between;
          padding: rem(10);
          // width: 45%;
          height: rem(75);
          // text-align: center;
          .img{
            display: inline-block;
            width: 53%;
            height: 100%;
          }
        }
        .product-title{
          height: rem(55);
          margin-top: rem(12);
          padding: rem(6);
          // text-align: center;
          color: #fff;
          font-size: 13px;
          word-break: break-word;
          /*font-weight: bold;*/
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          background: url(../../assets/img/floor.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
    .no-data{
      width: 60%;
      display: block;
      margin: 0 auto;
      text-align: center;
      color: #b1acac;
      font-size: rem(13);
      padding-bottom: rem(10);
      .hint-text{
        margin: rem(10) 0;
      }
    }
  }
}

</style>
